const planPage = {
  roadmapTitle: "Roadmap — vBrain.io",
  overallProgress: "Overall Progress",
  phase: "Phase",
  phaseRoutes: "Routes in phase",
  statusComplete: "Complete",
  statusInProgress: "In Progress",
  statusPlanned: "Planned",
  clickToChangeStatus: "Click to change status",
  noRoutes: "No routes",
  notes: "Notes",
  notesPlaceholder: "Phase notes — summary, risks, goals...",
  realtimeConnected: "Connected",
  realtimeConnecting: "Connecting...",
  realtimeDisconnected: "Disconnected",
  phase1Name: "Core Infrastructure",
  phase1Desc: "Sidebar, Layout, Layers, Settings, Automations",
  phase2Name: "Document Editor",
  phase2Desc: "Canvas Editor with field system and templates",
  phase3Name: "Story Map",
  phase3Desc: "Story Map with 3-tier drag & drop",
  phase4Name: "AI Hub",
  phase4Desc: "Claude API with work modes and streaming",
  phase5Name: "Content Pages",
  phase5Desc: "Design System, Functional Map, Architecture, Plan, Entities",
} as const;
export default planPage;
